import React from "react";
import ReactDOM from "react-dom";
import AvatarEditor from "react-avatar-editor";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@mantine/core";
import IconButton from "@material-ui/core/IconButton";
import OpenPreviewIcon from "@material-ui/icons/Visibility";
import ClosePreviewIcon from "@material-ui/icons/VisibilityOff";
import RotateIcon from "@material-ui/icons/RotateRight";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import placeholder from "../../registration/registermember/placeholder.jpg";

const styles = () => ({
  container: {
    display: "block",
    paddingTop: "300px",
    position: "relative",
    width: "100%",
  },
  imageContainer: {
    left: "50%",
    position: "absolute",
    top: 0,
    transform: "scale(0.5) translate(-50%, 0)",
    transformOrigin: "top left",
  },
  previewImage: {
    height: "580px",
    width: "580px",
  },
  activePersonPhotoContainer: {
    width: "300px",
    height: "300px",
    transform: "scale(2)",
    transformOrigin: "top",
    "@media(max-width: 576px)": {
      width: "250px",
      heigth: "250px",
    },
  },
  activePersonPhoto: {
    maxWidth: "100%",
    maxHeigth: "100%",
  },
  avatarActions: {
    display: "flex",
    justifyContent: "center",
    "& button": {
      margin: "0 4px",
    },
  },
  actionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    marginTop: "24px",
    padding: ".7rem",
    "& button": {
      marginLeft: "8px",
    },
  },
  placeholder: {
    display: "block",
    width: "500px",
    margin: "0 auto",
    borderRadius: "4px",
    cursor: "pointer",
  },
});

// const initialState = {
//   photo: null,
//   zoom: 1.2,
//   rotate: 0,
//   showPreview: false,
//   position: { x: 0.5, y: 0.5 },
//   previewImg: ""
// };

class Editor extends React.Component {
  constructor(props) {
    super(props);
    const getPhoto = () => {
      if (props.photo) {
        return props.photo.photoBase64;
      }
      return null;
    };
    this.state = {
      photo: getPhoto(),
      zoom: 1.2,
      rotate: 0,
      showPreview: false,
      position: { x: 0.5, y: 0.5 },
      previewImg: "",
    };
  }

  setPreview = () => {
    const canvasScaled = this.editor.getImageScaledToCanvas();
    this.setState({
      showPreview: true,
      previewImg: canvasScaled.toDataURL("image/jpeg", 1.0),
    });
  };

  onClickSave = () => {
    if (this.editor) {
      const canvasScaled = this.editor.getImageScaledToCanvas();
      this.props.savePhoto(canvasScaled.toDataURL("image/jpeg", 1.0));
      this.props.close && this.props.close();
    }
  };

  setEditorRef = (editor) => (this.editor = editor);
  handleZoomIn = () =>
    this.setState({
      zoom: (Number(this.state.zoom) + 0.1).toFixed(1),
    });
  handleZoomOut = () =>
    this.setState({
      zoom: (Number(this.state.zoom) - 0.1).toFixed(1),
    });
  openPhotoSelect = () => {
    const photoSelectDom = ReactDOM.findDOMNode(this.refs.photoSelect);
    return photoSelectDom.click();
  };
  render() {
    const { language, close, classes, activePerson, isNotLoggedIn } =
      this.props;

    return (
      <div className={classes.container}>
        <div className={classes.imageContainer}>
          {this.state.showPreview ? (
            <img
              src={this.state.previewImg}
              className={classNames(
                classes.previewImage,
                "avatar__preview-photo"
              )}
              alt="preview"
            />
          ) : this.state.photo ? (
            <AvatarEditor
              ref={this.setEditorRef}
              image={this.state.photo}
              crossOrigin="anonymous"
              width={500}
              height={500}
              border={40}
              position={this.state.position}
              onPositionChange={(pos) => this.setState({ position: pos })}
              color={[0, 0, 0, 0.6]} // RGBA
              scale={Number(this.state.zoom)}
              style={{ cursor: "move" }}
              rotate={Number(this.state.rotate)}
            />
          ) : isNotLoggedIn ? (
            <img
              src={placeholder}
              className={classes.placeholder}
              alt="member-placeholder"
              onClick={this.openPhotoSelect}
            />
          ) : (
            <div className={classes.activePersonPhotoContainer}>
              <img
                src={activePerson.photo}
                className={classes.activePersonPhoto}
                alt="active person"
              />
            </div>
          )}
        </div>
        <div className={classes.avatarActions}>
          {!this.state.showPreview && this.state.photo && (
            <>
              <IconButton
                onClick={this.handleZoomIn}
                disabled={Number(this.state.zoom) > 2.9}
              >
                <ZoomInIcon />
              </IconButton>
              <IconButton
                onClick={() =>
                  this.setState({ rotate: this.state.rotate + 90 })
                }
              >
                <RotateIcon />
              </IconButton>
              <IconButton onClick={this.setPreview}>
                <OpenPreviewIcon />
              </IconButton>
              <IconButton
                onClick={this.handleZoomOut}
                disabled={Number(this.state.zoom) < 0.9}
              >
                <ZoomOutIcon />
              </IconButton>
            </>
          )}
          {this.state.showPreview && this.state.photo && (
            <IconButton onClick={() => this.setState({ showPreview: false })}>
              <ClosePreviewIcon />
            </IconButton>
          )}
        </div>

        <div className={classes.actionContainer}>
          {close && !this.state.showPreview && (
            <>
              <Button
                onClick={this.openPhotoSelect}
                className="editor__photo-upload primaryButton"
              >
                {language.Choose_Photo
                  ? this.state.photo
                    ? language.Choose_New_Photo
                    : language.Choose_Photo
                  : ""}
              </Button>
              {!isNotLoggedIn && (
                <Button onClick={close} variant="subtle" color="dark">
                  {`${language.Abort}`}
                </Button>
              )}
              {!this.state.showPreview && this.state.photo && (
                <Button
                  onClick={() => this.onClickSave()}
                  className="editor__save-button primaryButton"
                >
                  {language.Save}
                </Button>
              )}
            </>
          )}
        </div>
        <input
          ref="photoSelect"
          style={{ display: "none" }}
          type="file"
          name="new-photo"
          onChange={(event) => this.setState({ photo: event.target.files[0] })}
        />
      </div>
    );
  }
}

export default withStyles(styles)(Editor);
